import {Component, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SistemaService} from '../../Servicios/Sistema.Service';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;
declare function Focus(id: string): any;

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any =
{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true
};

@Component(
    {
        selector: 'inputCustom',
        templateUrl: './Input.template.html',
        providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
    })

export class InputComponent implements ControlValueAccessor {
    public innerValue: string = "";

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    @Input() titulo: string = ""; // titulo del input
    @Input() type: string = "text"; // titulo del input
    @Input() pattern: any; // expresión regular para validar dato
    @Input() mask: any = false; // mascara del dato

    @Input() disabled: boolean = false; // control deshabilitado
    @Input() verError: boolean = true; // indica si el error esta habilitado para mostrarse
    @Input() errorActivo: boolean = false; // indica si el error esta habilitado para mostrarse
    @Input() mensajeError: string = ""; // indica el mensaje de error a mostrar
    @Input() maxLength: number = 999; // indica la longitud maxima del input
    @Input() uppercase: boolean = false; // indica si el input esta en mayusculas
    @Input() capitalize: boolean = false; // indica si el input esta en capitalize
    @Input() letrasNumeros: boolean = false; // indica si el input solo acepta letras y número

    public id: number = 0;

    constructor(public sistemaService: SistemaService, public translate: TranslateService) {
        this.sistemaService.numeroControl++;
        this.id = this.sistemaService.numeroControl;

    }

    ngOnInit() {
    }

    Focus() {
    }

    LimpiarValor() {
        this.valor = '';
        Focus("input" + this.id);
    }

    // control ngModel
    get valor(): string {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set valor(nuevoValor: string) {
        if (nuevoValor !== this.innerValue) {
            if (this.uppercase) {
                nuevoValor = nuevoValor.toUpperCase();
            } else if (this.capitalize) {
                nuevoValor = nuevoValor.replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
                var regex = /\b(?:De |La |Del )\b/g;
                nuevoValor = nuevoValor.replace(regex, match => match.toLowerCase())
            }

            this.innerValue = nuevoValor;
            this.onChangeCallback(nuevoValor);
        }
    }

    writeValue(valor: any) {
        if (valor !== this.innerValue) {
            this.innerValue = valor;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    TeclaPrecionada(key: any) {
        if (this.letrasNumeros) {
            if ((key.keyCode >= 48 && key.keyCode <= 57) || key.keyCode >= 97 && key.keyCode <= 122 || key.keyCode >= 65 && key.keyCode <= 90) {
            }
            else {
                key.preventDefault();
            }
        }
    }
}
